import React, { useEffect, useState, useRef, useContext } from 'react';

import './CuratedForYou.css';
import { ProductModalContext } from '../../ProductModalContext';
import STLImg1 from '../img/STLImg1.jpg'
import STLImg2 from '../img/STLImg2.jpg'
import STLImg3 from '../img/STLImg3.jpg'
import STLImg4 from '../img/STLImg4.jpg'
import STLImg5 from '../img/STLImg5.jpg'
import CuratedCard from './CuratedCard';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { CuratedProductClicked } from '../../../../../../utils/Analytics';
const isMobile = isMobileDevice();
const rightArrow = 'https://cdn.obsess-vr.com/ferragamo/stl-right-arrow.png'
const leftArrow = 'https://cdn.obsess-vr.com/ferragamo/stl-left-arrow.png'
import { withTranslation } from 'react-i18next';

const CuratedForYou = ({ relatedProductInfo, fragranceColorRemove, t }) => {
    const [productSize, setProductSize] = useState(5);
    const [leftArrowVisible, setLeftArrowVisible] = useState(false);
    const [rightArrowVisible, setRightArrowVisible] = useState(true);
    const [isUserScrolling, setIsUserScrolling] = useState(false);
    const scrollRef = useRef();
    const intervalRef = useRef();
    const { productSKU, setProductSKU, setSelectedRelatedSku } = useContext(ProductModalContext);
    const [selectedSKU, setSelectedSku] = useState("");
    
    useEffect(() => {
        setSelectedSku(productSKU);
    }, [])
    
    const setProductInfoFromRelated = (sku, name) => {
        CuratedProductClicked(name, sku);
        document.getElementById("product-modal-header").scrollIntoView({block: "start",behavior: "smooth"});
        setSelectedSku(sku)
        setProductSKU(sku);
        setSelectedRelatedSku(sku);
    }


    const renderCuratedCards = () => {
        return relatedProductInfo.map((product, index) => (

            (selectedSKU != product.sku) && <CuratedCard productInfo={product} key={index} fragranceColorRemove={fragranceColorRemove} setProductFromRelated={() => {
                setProductInfoFromRelated(product.sku, product.name)
            }} />

        ));
    }

    const handleScroll = (e) => {
        if (productSize.length <= 3) {
            return;
        }

        const scrollbar = scrollRef.current;
        const scrollLeft = scrollbar.scrollLeft;
        const scrollWidth = scrollbar.scrollWidth - scrollbar.clientWidth;
        const percentage = (scrollLeft / scrollWidth) * 100;

        if (percentage <= 0) {
            setLeftArrowVisible(false);
        } else if (percentage >= 90) {
            setRightArrowVisible(false);
        } else {
            // Seems redundant but will prevent event handler from constantly setting arrows to visible
            if (!leftArrowVisible) {
                setLeftArrowVisible(true);
            }
            if (!rightArrowVisible) {
                setRightArrowVisible(true);
            }
        }
    }

    const scrollStart = (e, direction) => {
        e.preventDefault();

        if (!isUserScrolling) {
            setIsUserScrolling(true);
            const scrollbar = scrollRef.current;
            const scrollWidth = scrollbar.scrollWidth - scrollbar.clientWidth;
            const scrollStep = isMobile ? 10 : 16;
            const scrollTimer = 20;
            setSideScroll(true, scrollbar, direction, scrollStep, scrollWidth, scrollTimer);
        }
    }

    const scrollEnd = (e) => {
        setTimeout(() => setSideScroll(false), 200);
    }

    const setSideScroll = (intervalStart, ref, direction, step, width, timer) => {
        if (intervalStart) {

            intervalRef.current = setInterval(() => {
                if (direction === 'right') {
                    ref.scrollLeft += step;
                } else {
                    ref.scrollLeft -= step;
                }

                if (ref.scrollLeft >= width) {
                    setIsUserScrolling(false);
                    clearInterval(intervalRef.current)
                } else if (ref.scrollLeft <= 0) {
                    setIsUserScrolling(false);
                    clearInterval(intervalRef.current)
                }
            }, timer);
        } else {
            setIsUserScrolling(false);
            clearInterval(intervalRef.current);
        }
    }

    return (
        <div className='stl-curated-for-you'>
            <h1>{t('curatedForYou')}</h1>
            <div className='stl-curated-card-wrapper' 
            ref={scrollRef} 
            onScroll={handleScroll}>
                {renderCuratedCards()}
            </div>

            <div className="stl-curated-nav">
                <div className="stl-curated-prev" 
                    style={{ visibility: leftArrowVisible ? 'visible' : 'hidden' }}
                    onMouseDown={(e) => { scrollStart(e, 'left') }}
                    onMouseUp={scrollEnd}
                    onTouchStart={(e) => { scrollStart(e, 'left') }}
                    onTouchEnd={scrollEnd} >
                </div>
                <div className="stl-curated-next"
                    style={{ visibility: rightArrowVisible ? 'visible' : 'hidden' }}
                    onMouseDown={(e) => { scrollStart(e, 'right') }}
                    onMouseUp={scrollEnd}
                    onTouchStart={(e) => { scrollStart(e, 'right') }}
                    onTouchEnd={scrollEnd} >
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(CuratedForYou);